import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';
import './style.scoped.scss';
import 'semantic-ui-css/semantic.min.css';
import Icon from '../../assets/images/favicon.png';

const mapStateToProps = (state) => ({
  docsList: state.client.documents,
});

const connector = connect(mapStateToProps, {});

const QueryType = ({
  isEmptyList,
  docsList,
  selectedDocs,
  handleCheckbox,
  selectedQuery,
  isQueryDisabled,
  rigthNavVisible,
  isLoading,
}) => {
  return (
    <React.Fragment>
      {!isLoading &&
        (isEmptyList ? (
          <span className='questionBox'>
            <b>Click on New Query to start.</b>
          </span>
        ) : isQueryDisabled === false || isQueryDisabled === null ? (
          <div
            className={`alert alert-danger ${
              rigthNavVisible ? '' : 'marginTop'
            }`}
            role='alert'
            style={{ marginTop: '2rem' }}
          >
            <b style={{ fontSize: '1.25rem' }}>
              One or more documents have been removed from your documents
              source, preventing us from proceeding with this query.
            </b>
          </div>
        ) : (
          <div className={`docsWrapper ${rigthNavVisible ? '' : 'marginTop'}`}>
            <div className='topHeader'>
              <div id='ai-icon'>
                <img src={Icon} alt='icon' />
              </div>
              <span className='questionBox'>
                {selectedQuery && selectedQuery.isFirstTime ? (
                  <b>
                    Query and extract information using Revealr AI. Select the
                    documents you would like to query information:
                  </b>
                ) : (
                  <b>Querying from Documents:</b>
                )}
              </span>
            </div>

            <Dropdown
              placeholder='Select Documents'
              fluid
              multiple
              search
              selection
              options={
                docsList &&
                docsList.length > 0 &&
                docsList
                  .filter((doc) => doc.status === 'Published')
                  .sort((a, b) =>
                    a.title.localeCompare(b.title, undefined, { numeric: true })
                  )
                  .map((doc) => ({
                    text: doc.title,
                    value: doc.id,
                  }))
              }
              onChange={(e, data) => handleCheckbox(e, data)}
              value={selectedDocs}
              disabled={
                selectedQuery && !selectedQuery.isFirstTime ? true : false
              }
            />
          </div>
        ))}
    </React.Fragment>
  );
};

export default connector(QueryType);
